import Routes from '../Components/Routes'

function Portfolio() {
    
  return (
    <>
        <Routes />
    </>
  );
};

export default Portfolio;